import React from "react";
import { Box, IconButton, Textarea } from "@mui/joy";
import { theme } from "styles/theme";

export function ChatInput({
  value,
  onChange,
  onSubmit,
  disabled,
  placeholder,
}: {
  value: string;
  onChange: (v: string) => void;
  onSubmit: () => void;
  disabled: boolean;
  placeholder?: string;
}) {
  const handleKeyDown = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.key === "Enter" && !e.shiftKey && !e.nativeEvent.isComposing) {
      e.preventDefault();
      if (!disabled && value.trim()) onSubmit();
    }
  };
  return (
    <Box
      sx={{
        m: "8px 12px 12px",
        display: "flex",
        alignItems: "center",
        gap: "6px",
        p: "6px 6px 6px 12px",
        borderRadius: "16px",
        backgroundColor: theme.vars.palette.Surface.Forward,
        border: `1px solid ${theme.vars.palette.Border.Weak}`,
        boxShadow: "0 6px 20px rgba(15, 23, 42, 0.08)",
        transition: "box-shadow 0.15s ease, border-color 0.15s ease",
        "&:focus-within": {
          borderColor: theme.vars.palette.Border.Highlight,
          boxShadow: "0 8px 24px rgba(15, 23, 42, 0.10)",
        },
      }}
    >
      <Textarea
        variant="plain"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onKeyDown={handleKeyDown}
        placeholder={placeholder}
        minRows={1}
        maxRows={6}
        disabled={disabled}
        sx={{
          flex: 1,
          fontSize: "13px",
          backgroundColor: "transparent",
          "--Textarea-focusedHighlight": "transparent",
          "&::before": { display: "none" },
          "&:hover": { backgroundColor: "transparent" },
        }}
      />
      <IconButton
        variant="solid"
        color="primary"
        onClick={onSubmit}
        disabled={disabled || !value.trim()}
        sx={{
          minHeight: "32px",
          minWidth: "32px",
          fontSize: "15px",
          borderRadius: "999px",
          backgroundColor: theme.vars.palette.primary.solid,
          color: theme.vars.palette.common.white,
          "&:hover": {
            backgroundColor: theme.vars.palette.primary.solid,
            opacity: 0.9,
          },
          "&.Mui-disabled": {
            backgroundColor: theme.vars.palette.primary.deactivated,
            color: theme.vars.palette.common.white,
          },
        }}
        title="전송 (Enter)"
      >
        ↑
      </IconButton>
    </Box>
  );
}
